import { SUBSCRIPTION_STATUS, SUBSCRIPTION_PLAN_NAME_MAP } from '../../constants'

export const subscription = {
  namespaced: true,
  state: {
    subscription: null,
    availablePlan: null,
    modals: [],
    subscriptionLink: null,
  },
  mutations: {
    init(state, initialState) {
      if (initialState.subscription && Object.keys(initialState.subscription).length > 0) {
        state.subscription = initialState.subscription
      }

      if (initialState.availablePlan && Object.keys(initialState.availablePlan).length > 0) {
        state.availablePlan = initialState.availablePlan
      }
      if (initialState.modals && Array.isArray(initialState.modals)) {
        state.modals = initialState.modals
      }
      if (initialState.subscriptionLink) {
        state.subscriptionLink = initialState.subscriptionLink
      }
    },
    removeModal(state, modalName) {
      state.modals = state.modals.filter((name) => name !== modalName)
    },
    addModal(state, modalName) {
      if (!state.modals.includes(modalName)) {
        state.modals.push(modalName)
      }
    },
  },
  actions: {
    init(context, initialState) {
      console.debug('Subscription store initialized with:', initialState)
      context.commit('init', initialState)
    },
    removeModal(context, modalName) {
      context.commit('removeModal', modalName)
    },
    addModal(context, modalName) {
      context.commit('addModal', modalName)
    },
  },
  getters: {
    subscription: (state) => state.subscription,
    isSubscriptionFree: (state) =>
      state.subscription && state.subscription.provider === 'skokka_free',
    isSubscriptionActive: (state) =>
      state.subscription && state.subscription?.status === SUBSCRIPTION_STATUS.ACTIVE,
    isSubscriptionExpired: (state) =>
      state.subscription && state.subscription.status === SUBSCRIPTION_STATUS.EXPIRED,
    isSubscriptionCancelled: (state) =>
      state.subscription && state.subscription.status === SUBSCRIPTION_STATUS.CANCELLED,
    isSubscriptionCancelRequested: (state) =>
      state.subscription && state.subscription.status === SUBSCRIPTION_STATUS.CANCEL_REQUESTED,
    availablePlan: (state) => state.availablePlan,
    availablePlanName: (state) => SUBSCRIPTION_PLAN_NAME_MAP[state.availablePlan?.logical_id],
    benefits: (state) => state.availablePlan?.benefits,
    isModalVisible: (state) => (modalName) => state.modals.includes(modalName),
    expirationDate(state) {
      if (!state.subscription || !state.subscription.expiration_date) return ''
      const expirationDate = new Date(state.subscription.expiration_date)
      const expirationMonth = expirationDate.toLocaleDateString(locations.language, {
        month: 'short',
      })
      const expirationYear = expirationDate.getFullYear()
      const expirationDay = expirationDate.getDate()
      return `${expirationDay} ${expirationMonth} ${expirationYear}`
    },
    nextPaymentDate(state) {
      if (!state.subscription || !state.subscription.next_payment_date) return ''
      const nextPaymentDate = new Date(state.subscription.next_payment_date)
      const nextPaymentMonth = nextPaymentDate.toLocaleDateString(locations.language, {
        month: 'short',
      })
      const nextPaymentYear = nextPaymentDate.getFullYear()
      const nextPaymentDay = nextPaymentDate.getDate()
      return `${nextPaymentDay} ${nextPaymentMonth} ${nextPaymentYear}`
    },
    subscriptionLink: (state) => state.subscriptionLink,
  },
}
